type SelectOption = { id: string; name: string; value: string };

export const EMPLOYER_OPTIONS: SelectOption[] = [
  { id: "region", name: "Region", value: "Region" },
  { id: "municipality", name: "Kommun", value: "Kommun" },
  { id: "municipalCompany", name: "Kommunalt företag", value: "Kommunalt företag" },
  { id: "tradeUnion", name: "Ett fackförbund", value: "Ett fackförbund" },
  {
    id: "multipleEmployersWithMunicipal",
    name: "Hos flera arbetsgivare, men minst en inom kommun/region",
    value: "Hos flera arbetsgivare, men minst en inom kommun/region",
  },
  { id: "privateCompany", name: "Privat företag", value: "Privat företag" },
  {
    id: "selfEmployed",
    name: "Jag är egenföretagare/frilansare/konsult",
    value: "Jag är egenföretagare/frilansare/konsult",
  },
  {
    id: "notEmployed",
    name: "Jag är inte anställd just nu",
    value: "Jag är inte anställd just nu",
  },
  {
    id: "other",
    name: "Annan beskrivning passar bättre",
    value: "Annan beskrivning passar bättre",
  },
];
